import {
    CredentialFlowState,
    FetchState,
    IdentityOption,
} from "@/shared/types";
import * as UserService from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import _ from "lodash";
import { defineStore } from "pinia";

export const initialState: CredentialFlowState = {
    bendUserId: "",
    phone: "",
    mobilePhone: "",
    username: "",
    email: "",
    identityOptionsFetchState: FetchState.Uninitialized,
    identityOptions: [],
    selectedIdentityOption: null,
    signature: "",
    accountNumber: "",
    isEmailVerified: {},
};

export const useCredentialFlowStore = defineStore("credentialFlow", {
    state: (): CredentialFlowState => (_.cloneDeep(initialState)),
    getters: {
        credentialFlowUsername: state => state.username,
        isIdentityOptionsLoaded: state => state.identityOptionsFetchState === FetchState.Loaded,
    },
    actions: {
        setBendUserId (bendUserId: string) {
            this.bendUserId = bendUserId;
        },
        setPhone (phone: string) {
            this.phone = phone;
        },
        setMobilePhone (mobilePhone: string) {
            this.mobilePhone = mobilePhone;
        },
        setCredentialFlowUsername (username: string) {
            this.username = username;
        },
        setEmail (email: string) {
            this.email = email;
        },
        setSelectedIdentityOption (option: IdentityOption) {
            this.selectedIdentityOption = option;
        },
        setIdentityOptionsFetchState (identityOptionsFetchState: FetchState) {
            this.identityOptionsFetchState = identityOptionsFetchState;
        },
        setIdentityOptions (identityOptions: IdentityOption[]) {
            this.identityOptions = identityOptions;
        },
        setSignature (signature: string) {
            this.signature = signature;
        },
        setAccountNumber (accountNumber: string) {
            this.accountNumber = accountNumber;
        },
        setIsEmailVerified (args: { email: string, isVerified: boolean }) {
            this.isEmailVerified[args.email] = args.isVerified;
        },
        loadIdentityOptions (username: string) {
            if (this.identityOptionsFetchState !== FetchState.Uninitialized && this.username === username) {
                return;
            }

            this.setIdentityOptionsFetchState(FetchState.Loading);

            return UserService.identityProofingOptions(username)
                .then(response => {
                    this.setIdentityOptionsFetchState(FetchState.Loaded);

                    if (response && response.data && response.data.proofingOptions) {
                        const options = _.orderBy(response.data.proofingOptions, [ "priorityOrder" ], [ "asc" ]);
                        this.setIdentityOptions(options);
                    }
                })
                .catch(e => storeHelper.handleError({ error: e, rethrow: false }))
                .finally(() => this.setIdentityOptionsFetchState(FetchState.Loaded));
        },
        resetIdentityOptionsFetchState () {
            this.setIdentityOptionsFetchState(FetchState.Uninitialized);
        }
    }
});
